module.exports = __webpack_public_path__ + "static/media/so-algo-duck2.a18efd48.jpg";